import api from '@/api/users';
import store from '@/store';

const fetchUserByEmail = (context, email) =>
  new Promise((resolve, reject) => {
    api
      .userByEmail(email)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const authWithDKTSSO = (context, data, loggedInUserProfile) =>
  new Promise((resolve, reject) => {
    api
      .authWithDKTSSO(data)
      .then((response) => {
        if (loggedInUserProfile && loggedInUserProfile._id !== response._id) {
          store.commit('removeXTokenFromCookie');
          context.dispatch('idpLogOut');
          store.dispatch('device/deleteDevice');
          context.dispatch('logout');
          window.localStorage.clear();
        }

        const authToken = response.apiKeys[0].key;
        const userToken = response.token;
        context.commit('storeUserToken', userToken, { root: true });
        context.commit('storeToken', authToken, { root: true });
        store.commit('settings/SET_SESSION_EXPIRED', undefined);
        store.commit('settings/SET_HANDLED_UNAUTHORIZED_ERROR', undefined);

        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const authWithSocialNetwork = (context, credentials) =>
  new Promise((resolve, reject) => {
    api
      .authWithSocialNetwork(credentials)
      .then((response) => {
        const authToken = response.apiKeys[0].key;
        const userToken = response.token;
        context.commit('storeUserToken', userToken, { root: true });
        context.commit('storeToken', authToken, { root: true });
        store.commit('settings/SET_SESSION_EXPIRED', undefined);
        store.commit('settings/SET_HANDLED_UNAUTHORIZED_ERROR', undefined);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const updateUser = (context, user) =>
  new Promise((resolve, reject) => {
    api
      .updateUser(user)
      .then((response) => {
        context.commit('SAVE_USER_PROFILE', response.data);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const registerWithEmail = (context, regData) =>
  new Promise((resolve, reject) => {
    api
      .registerWithEmail(regData)
      .then((response) => {
        const authToken = response.data.apiKeys[0].key;
        const userToken = response.data.token;
        context.commit('storeUserToken', userToken, { root: true });
        context.commit('storeToken', authToken, { root: true });
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const loginWithEmail = (context, loginData) =>
  new Promise((resolve, reject) => {
    api
      .loginWithEmail(loginData)
      .then((response) => {
        const authToken = response.data.apiKeys[0].key;
        const userToken = response.data.token;
        context.commit('storeUserToken', userToken, { root: true });
        store.commit('storeToken', authToken, { root: true });
        store.commit('settings/SET_SESSION_EXPIRED', undefined);
        store.commit('settings/SET_HANDLED_UNAUTHORIZED_ERROR', undefined);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const loginWithFacebook = (context, credential) =>
  new Promise((resolve, reject) => {
    api
      .loginWithFacebook(credential)
      .then((response) => {
        const authToken = response.apiKeys[0].key;
        const userToken = response.token;
        context.commit('storeUserToken', userToken, { root: true });
        context.commit('storeToken', authToken, { root: true });
        store.commit('settings/SET_SESSION_EXPIRED', undefined);
        store.commit('settings/SET_HANDLED_UNAUTHORIZED_ERROR', undefined);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const loginWithGoogle = (context, credential) =>
  new Promise((resolve, reject) => {
    api
      .loginWithGoogle(credential)
      .then((response) => {
        const authToken = response.apiKeys[0].key;
        const userToken = response.token;
        context.commit('storeUserToken', userToken, { root: true });
        context.commit('storeToken', authToken, { root: true });
        store.commit('settings/SET_SESSION_EXPIRED', undefined);
        store.commit('settings/SET_HANDLED_UNAUTHORIZED_ERROR', undefined);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const loginWithApple = (context, data) =>
  new Promise((resolve, reject) => {
    const credential = {
      appleAuthToken: data.appleAuthToken,
      platform: data.platform,
      fullName: data.fullName
    };
    api
      .loginWithApple(credential)
      .then((response) => {
        const authToken = response.apiKeys[0].key;
        const userToken = response.token;
        context.commit('storeUserToken', userToken, { root: true });
        context.commit('storeToken', authToken, { root: true });
        store.commit('settings/SET_SESSION_EXPIRED', undefined);
        store.commit('settings/SET_HANDLED_UNAUTHORIZED_ERROR', undefined);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const registerDevice = context =>
  new Promise((resolve, reject) => {
    const reqData = {
      name: store.getters['device/deviceName'],
      platform: 'web',
      deviceToken: store.getters['device/deviceToken'],
      clientVersion: '1.0.0'
    };
    api
      .registerDevice(reqData)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const generatePasswordReset = (context, email) =>
  new Promise((resolve, reject) => {
    api
      .generatePasswordReset(email)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const resetPassword = (context, passwordData) =>
  new Promise((resolve, reject) => {
    api
      .resetPassword(passwordData)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getLoggedInUserProfile = context =>
  new Promise((resolve, reject) => {
    api
      .getLoggedInUserProfile()
      .then((response) => {
        context.commit('SAVE_USER_PROFILE', response.data);
        const userToken = response.data.token;
        context.commit('storeUserToken', userToken, { root: true });
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const deleteUserProfile = context =>
  new Promise((resolve, reject) => {
    api
      .deleteUserProfile()
      .then((response) => {
        store.commit('device/DESTROY_DEVICE');
        resolve(response);
      })
      .catch(error => reject(error));
  });

const logout = (context, obj) =>
  new Promise((resolve, reject) => {
    store.commit('removeXTokenFromCookie');
    store.commit('storeToken', undefined);
    store.commit('storeUserToken', undefined);
    store.commit('device/DESTROY_DEVICE');
    store.commit('settings/DESTROY');
    store.commit('users/DESTROY', undefined);
    store.commit('settings/SET_GUEST_LINK', undefined);
    resolve(true);
  });

const deleteAvatar = context =>
  new Promise((resolve, reject) => {
    api
      .deleteAvatar()
      .then((response) => {
        context.commit('SAVE_USER_PROFILE', response.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const uploadAvatar = (context, blob) =>
  new Promise((resolve, reject) => {
    api
      .uploadAvatar(blob)
      .then((response) => {
        context.commit('SAVE_USER_PROFILE', response.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const changePassword = (context, passwords) =>
  new Promise((resolve, reject) => {
    api
      .changePassword(passwords)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const updateUserStore = (context, userObj) =>
  new Promise((resolve, reject) => {
    context.commit('SAVE_USER_PROFILE', userObj);
  });

const changedPushNotificationStatus = (context, data) =>
  new Promise((resolve, reject) => {
    api
      .changedPushNotificationStatus(data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getUsageStatistics = context =>
  new Promise((resolve, reject) => {
    api
      .getUsageStatistics()
      .then((response) => {
        context.commit('SAVE_ME_USAGE_STATISTICS', response);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getSyncStatusPoll = context =>
  new Promise((resolve, reject) => {
    api
      .getSyncStatusPoll()
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const idpKeepSignIn = context =>
  new Promise((resolve, reject) => {
    api
      .idpKeepSignIn()
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

function logoutFromKreta() {
  if (location.hostname !== 'localhost') {
    fetch(
      `${process.env.VUE_APP_IDP_AUTH_CONFIG_URL}/.well-known/openid-configuration`
    ).then(async (response) => {
      const res = await response.json();
      if (res.end_session_endpoint) {
        const a = document.createElement('a');
        a.href = res.end_session_endpoint;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    });
  }
}

const idpLogOut = context =>
  new Promise((resolve, reject) => {
    // if (context.getters.isDktUser) {
    //   logoutFromKreta();
    // }
    api
      .idpLogOut()
      .then((response) => {
        store.commit('removeXTokenFromCookie');
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const createTeacherStatistics = (context, value) =>
  new Promise((resolve, reject) => {
    api
      .createTeacherStatistics(value)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export default {
  fetchUserByEmail,
  authWithSocialNetwork,
  authWithDKTSSO,
  updateUser,
  registerWithEmail,
  loginWithEmail,
  loginWithFacebook,
  loginWithGoogle,
  loginWithApple,
  registerDevice,
  generatePasswordReset,
  resetPassword,
  getLoggedInUserProfile,
  deleteUserProfile,
  logout,
  deleteAvatar,
  uploadAvatar,
  changePassword,
  updateUserStore,
  changedPushNotificationStatus,
  getUsageStatistics,
  getSyncStatusPoll,
  idpKeepSignIn,
  idpLogOut,
  createTeacherStatistics
};



// WEBPACK FOOTER //
// ./src/store/modules/users/actions.js